import { render, staticRenderFns } from "./PmAlarmQueryRightList.vue?vue&type=template&id=352c0c36&"
import script from "./PmAlarmQueryRightList.vue?vue&type=script&lang=js&"
export * from "./PmAlarmQueryRightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports